import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'circular-progress',
  templateUrl: './circular-progress.component.html',
  styleUrls: ['./circular-progress.style.scss'],
  host: {
    class: 'circular-progress-sc',
  },
})
export class CircularProgressComponent extends BaseComponent implements OnInit {
  @Input()
  size: 'sm' | 'md' = 'md';
  @Input() value: number = 50;
  @Input() displayValue: string = '';
  @Input() diameter: number = 32;
  @Input() cutoutDiameter: number = 30;
  @Input() disableCheckSymbol: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {}
}
